/* eslint-disable no-underscore-dangle */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import NavB from '../../../Nav/NavB';
import VideoPlayer from '../../components/VideoPlayer';
import styles from './css/Course.module.scss';
import Loader from '../../components/Loader';
import { auth } from '../../../util';

const options = {
  theme: 'light',
  position: 'bottom-right',
  autoClose: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

const Course = () => {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const [moduleStatus, setModuleStatus] = useState({});
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [isError, setIsError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchCourse = async () => {
      try {
        setIsLoading(true);
        if (!courseId) {
          setIsError('Course not found');
          setIsLoading(false);
          return;
        }
        const response = await auth.get(`/courses/${courseId}`);

        if (response.status !== 200) {
          setIsError('Failed to fetch course');
          toast.error('Check your internet connection and try again', options);
          setIsLoading(false);
          navigate(-1);
        }

        const data = await response.data;
        setSelectedCourse(data);

        const initialStatus = data.modules.reduce((acc, module, index) => {
          acc[module._id] = index === 0;
          return acc;
        }, {});
        setModuleStatus(initialStatus);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setIsError(error.message);
        toast.error('Something went wrong, try again', options);
        navigate(-1);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCourse();
  }, [courseId, navigate]);

  if (isError) {
    return (
      <div>
        Error: Check your network connection and try again
      </div>
    );
  }

  if (isLoading) {
    return <Loader loading={isLoading} />;
  }

  const handleClick = (module, index) => {
    if (!moduleStatus[module._id]) {
      toast.info("Not available until you've completed the previous module.", options);
      return;
    }
    navigate(`/palmschool/courses/${courseId}/${module._id}`);
    setModuleStatus((prevStatus) => ({
      ...prevStatus,
      [module._id]: true,
      ...(selectedCourse.modules[index + 1] && { [selectedCourse.modules[index + 1]._id]: true }),
    }));
  };

  return (
    <>
      <NavB palmschool palmtrack={false} palmstore={false} palmvest={false} />
      <section className={styles.container}>
        <div className={styles.div}>
          <h1 className={styles.title}>{ selectedCourse && selectedCourse.title}</h1>
        </div>
        <VideoPlayer videoSrc="https://res.cloudinary.com/dn1ko8lbn/video/upload/v1723043676/Palmshops/Introduction/intro.mp4" />
        <div className={styles.modules}>
          <h3 className={styles.courseTitle}>Modules</h3>
          <div className={styles.courseDiv}>
            {selectedCourse && selectedCourse.modules.map((module, index) => (
              <div
                key={module._id}
                className={`${styles.course} ${!moduleStatus[module._id] ? styles.disabled : ''}`}
                onClick={() => handleClick(module, index)}
              >
                <h2 className={styles.courseId}>{module.id}</h2>
                <img src={module.img} className={styles.img} alt={module.subtopic} />
                <div className={styles.courseAction}>
                  <article className={styles.courseBrief}>
                    <h4 className={styles.courseTitle}>{module.subtopic}</h4>
                    <p className={styles.courseText}>{module.description}</p>
                  </article>
                  <article className={styles.tracker}>
                    <p className={styles.trackerTimer}>
                      {module.duration}
                      <span>mins</span>
                    </p>
                    <progress className={styles.trackerPercent} value={module.progress || 10} max={module.duration} />
                  </article>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Course;
